<template>
  <div v-title :data-title="$route.name">
    <!-- style=" border-style: solid; border-width: 5px; border-color: transparent;" -->
    <div
      v-if="offsetwidth > 850"
      style="
        width: 100%;
        overflow: hidden;
        position: relative;
        min-width: 1349px;
        margin-top: 65px;
        background-color: white !important;
      "
    >
      <div style="position: relative">
        <img
          style="width: 100%; height: 100%; object-fit: cover"
          src="../assets/Battertimg/PC/productBanner.jpg"
          alt=""
        />
        <div
          style="
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            color: white !important;
            text-align: center;
            z-index: 10;
            width: 100%;
          "
        >
          <div
            style="
              font-size: 48px;
              font-family: Cotyledon-Regular-bold;
              line-height: 1;
              margin-bottom: 8px;
              width: 100%; /* 继承父级宽度 */
              text-align: center; /* 文本水平居中 */
            "
          >
            Products
          </div>
        </div>
      </div>

      <div class="product-page">
        <!-- 分类导航 -->
        <div class="categories">
          <div class="category-itemtitle">Category</div>
          <div
            v-for="category in categories"
            :key="category.ProductTypeId"
            :class="[
              'category-item',
              { active: activeCategory === category.ProductTypeId },
            ]"
            @click="changeCategory(category.ProductTypeId)"
          >
            <div class="pos_rel">
              <div>{{ category.ProductTypeName }}</div>
              <div
                v-if="activeCategory === category.ProductTypeId"
                class="pos_abs"
                style="right: -15px; top: 0; width: 20px"
              >
                >
              </div>
            </div>
          </div>
        </div>

        <div>
          <!-- 产品列表 -->
          <div class="products-grid">
            <div
              v-for="(product, index) in products"
              :key="index"
              class="product-item"
              @mouseenter="hoverProduct = product.ProductId"
              @mouseleave="hoverProduct = null"
              :class="{
                'active-product':
                  activeProduct === product.ProductId ||
                  hoverProduct === product.ProductId,
              }"
              @click="selectProduct(product.ProductId)"
            >
              <div class="flex flex_around">
                <div style="object-fit: fill">
                  <img :src="product.FilePath" :alt="product.name" />
                </div>
              </div>
              <div class="product-info">
                <div
                  class="product-name"
                  style="font-family: Cotyledon-Regular-bold"
                >
                  {{ product.ProductName }}
                </div>
                <div class="product-name_KeyPra" style="text-align: center">
                  {{ product.KeyPrarameters }}
                </div>

                <div class="product-line"></div>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="flex flex_around">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="pageIndex"
              :page-size="6"
              layout=" prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!-- 底部导航 -->
      <footer class="header-navbar">
        <!-- 第一行：LOGO和导航项 -->
        <div class="top-nav" style="height: 28px !important">
          <div class="logo-container">
            <div class="logo">
              <img
                style="height: 28px !important"
                src="../assets/Battertimg/PC/Batteryplantlogo.png"
                alt=""
              />
            </div>
          </div>

          <div class="nav-items">
            <div class="nav-item" @click="goto('HOME')">HOME</div>
            <div class="nav-item" @click="goto('PROJECT')">ABOUT US</div>
            <div class="nav-item" @click="goto('PRODUCTS')">PRODUCTS</div>
            <div class="nav-item" @click="goto('CASE')">GALLERY</div>
            <div class="nav-item" @click="goto('CONTACTUS')">CONTACT US</div>
            <div class="nav-item" @click="goto('CONTACTUS')">BOOK NOW</div>
          </div>
        </div>
        <div
          style="
            height: 1px;
            background-color: #cccccc;
            margin-top: 15px;
            margin-bottom: 18px;
          "
        ></div>
        <!-- 间距30px后的邮件信息 -->
        <div>
          <div class="email-content">(04) 5245 7579</div>
          <div class="email-content">info@batteryplant.com.au</div>
          <div class="email-content">
            203 Blackburn Rd Mount Waverley VIC 3149
          </div>
        </div>
      </footer>
    </div>
    <div
      v-else
      style="
        width: 100%;
        overflow: hidden;
        background-color: #fff;
        position: relative;
      "
    >
      <div
        style="
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          overflow: hidden;
          font-size: 24px;
          padding: 12px 0;
          color: #fff;
          font-weight: bold;
        "
      >
        <img
          style="height: 48px"
          src="../assets/Battertimg/H5/ProductBanner.jpg"
          alt=""
        />
        <div class="pos_abs">Products</div>
      </div>
      <!-- 分组 -->
      <div
        v-for="(category, categoryindex) in categoryList"
        :key="categoryindex"
      >
        <div
          class="flex text_center flex_around"
          style="
            font-size: 20px;
            margin-top: 20px;
            margin-bottom: 10px;
            width: 100%;
          "
        >
          <div
            style="
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              overflow: hidden;
            "
          >
            <img
              style="width: 85.3%"
              src="../assets/Battertimg/H5/bgtitlebar.png"
              alt=""
            />
            <div
              class="pos_abs"
              style="
                font-family: Cotyledon-Regular-bold;
                text-align: center;
                font-size: 18px;
              "
            >
              <div>
                {{ category.ProductTypeName }}
              </div>
            </div>
          </div>
        </div>
        <el-row style="margin-bottom: 69px" :gutter="24">
          <el-col :span="24">
            <div>
              <div>
                <el-carousel
                  :class="category.ProductTypeName"
                  :ref="
                    (el) => {
                      refs[categoryindex] = el;
                    }
                  "
                  indicator-position="outside"
                  height="320px"
                  trigger="click"
                  :interval="10000"
                  arrow="always"
                  :effect="'creative'"
                  @change="
                    (index) => {
                      category.ProductTypeNameActive = index;
                    }
                  "
                >
                  <!-- @touchstart.passive="slideBanner(category.ProductTypeName)" -->

                  <el-carousel-item
                    style="
                      display: flex;
                      height: 320px;
                      justify-items: center;
                      align-items: center;
                      justify-content: space-around;
                    "
                    v-for="(item, index) in category.productsList"
                    :key="index"
                  >
                    <div
                      style="
                        width: 85.3%;
                        height: 320px;
                        background-color: rgb(239, 246, 252);
                      "
                      class="creative-slide flex flex_around"
                      :class="{
                        'active-slide':
                          category.ProductTypeNameActive === index,
                      }"
                    >
                      <!--  -->
                      <div
                        @click="LearnMore(item.ProductId)"
                        style="text-align: center; position: relative"
                      >
                        <div class="flex flex_around">
                          <img
                            class="slide-image"
                            ref="imgHeight"
                            :src="item.FilePath"
                            :alt="item.ProductName"
                            style="
                              height: 150px;
                              width: auto;
                              margin-top: 20px;
                              display: block;
                            "
                          />
                        </div>

                        <div class="flex flex_around">
                          <div style="text-align: center; margin-bottom: 20px">
                            <div
                              style="
                                font-size: 15px;
                                font-family: Cotyledon-Regular-bold;
                              "
                            >
                              {{ item.ProductName }}
                            </div>
                            <div
                              style="
                                display: inline-block;
                                width: 85.3%;
                                font-size: 12px;
                                color: #666;
                                padding: 15px 20px;
                              "
                            >
                              {{ item.KeyPrarameters }}
                            </div>
                            <div>
                              <el-button
                                style="
                                  font-size: 15px;
                                  border-width: 2px;
                                  width: 140px;
                                  height: 28px;
                                  padding: 0 15px;
                                "
                                size="mini"
                                round
                                type="primary"
                                plain
                                >Learn More</el-button
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
              <!-- <img
                style="width: 85.3%"
                src="../assets/Battertimg/H5/bgBar.png"
                alt=""
              /> -->
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- 在移动端部分（v-else内）修改底部导航栏 -->
      <footer class="mobile-footer-navbar">
        <!-- 垂直排列的容器 -->
        <div class="vertical-container">
          <!-- LOGO区域 -->
          <div class="logo-section">
            <div class="logo-container">
              <div class="logo">
                <img
                  style="height: 28px !important"
                  src="../assets/Battertimg/PC/Batteryplantlogo.png"
                  alt="Battery Plant Logo"
                />
              </div>
            </div>
          </div>

          <!-- 导航项区域（手动编写每个项） -->
          <div class="nav-section">
            <div
              class="nav-item"
              :class="{ active: activeNav === 0 }"
              @click="
                activateNav(0);
                goto('HOME');
              "
            >
              HOME
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 1 }"
              @click="
                activateNav(1);
                goto('PROJECT');
              "
            >
              ABOUT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 2 }"
              @click="
                activateNav(2);
                goto('PRODUCTS');
              "
            >
              PRODUCTS
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 3 }"
              @click="
                activateNav(3);
                goto('CASE');
              "
            >
              GALLERY
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 4 }"
              @click="
                activateNav(4);
                goto('CONTACTUS');
              "
            >
              CONTACT US
            </div>

            <div
              class="nav-item"
              :class="{ active: activeNav === 5 }"
              @click="
                activateNav(5);
                goto('CONTACTUS');
              "
            >
              BOOK NOW
            </div>
          </div>
          <div style="height: 1px; background-color: #cccccc"></div>
          <!-- 邮件信息区域 -->
          <div class="contact-section">
            <div class="email-contentmobile">(04) 5245 7579</div>
            <div class="email-contentmobile">info@batteryplant.com.au</div>
            <div class="email-contentmobile">
              203 Blackburn Rd Mount Waverley VIC 3149
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { get } from "../assets/api/api";
import {
  ProductSummarizeList,
  WebsiteProductType,
} from "../assets/api/request";
export default {
  props: {
    offsetwidth: {
      type: Number,
    },
  },
  data() {
    return {
      activeNav: null, // 跟踪当前激活的导航项
      categories: [
        // { ProductTypeId: 1, ProductTypeName: "家庭储能" },
        // { ProductTypeId: 2, ProductTypeName: "逆变器" },
        // { ProductTypeId: 3, ProductTypeName: "太阳能板" },
        // { ProductTypeId: 4, ProductTypeName: "配件" },
      ],
      products: [
        // {
        //   id: 1,
        //   categoryId: 1,
        //   name: "11KTLX-G3",
        //   image: "../assets/Battertimg/PC/电池1.png",
        //   specs: "51.2V 100Ah | 5.12千瓦时 | LFP",
        // },
        // {
        //   id: 2,
        //   categoryId: 1,
        //   name: "HECONICS 储能",
        //   image: "https://via.placeholder.com/300x300?text=Product2",
        //   specs: "48V 200Ah | 10.24千瓦时 | LFP",
        // },
        // {
        //   id: 3,
        //   categoryId: 1,
        //   name: "家用储能系统",
        //   image: "https://via.placeholder.com/300x300?text=Product3",
        //   specs: "25.6V 150Ah | 3.84千瓦时 | LFP",
        // },
      ],
      categoryList: [
        {
          ProductTypeId: 0,
          ProductTypeName: "",
          ProductTypeNameActive: 0,
          productsList: [],
        },
      ],
      pageIndex: 1,
      total: 0,
      imgHeight: 0,
      activeCategory: null,
      hoverProduct: null,
      activeProduct: null,
      refs: [],
    };
  },

  created() {
    this.activeCategory = sessionStorage.getItem("ProductId");
    // this.fetchCategories()
    this.getCategory();
  },
  // watch: {
  //   categoryList(nval, oval) {
  //     nval.forEach((item) => {
  //       console.log(this.$refs[item.ProductTypeName], "name", nval);

  //       this.slideBanner(item.ProductTypeName);
  //     });
  //   },
  // },
  mounted() {
    document.documentElement.scrollTop = 0;
  },
  updated() {},
  methods: {
    // 滑动切换
    slideBanner(index) {
      const ref = this.refs[index];
      const box = document.querySelectorAll(".el-carousel__container");
      if (!box[index]) return;

      let startPointX = 0;
      let stopPointX = 0;

      const resetPoint = function () {
        startPointX = 0;
        stopPointX = 0;
      };

      box[index].addEventListener("touchstart", function (e) {
        startPointX = e.changedTouches[0].pageX;
      });

      box[index].addEventListener("touchmove", function (e) {
        stopPointX = e.changedTouches[0].pageX;
      });

      const that = this;
      box[index].addEventListener("touchend", function (e) {
        if (stopPointX === 0 || startPointX - stopPointX === 0) {
          resetPoint();
          return;
        }

        if (startPointX - stopPointX > 0) {
          resetPoint();
          ref.next();

          return;
        }

        if (startPointX - stopPointX < 0) {
          resetPoint();
          ref.prev();

          return;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getActiveProductList(this.activeCategory);
    },
    getCategory() {
      get(WebsiteProductType).then((res) => {
        this.Swipercontainer = [];
        this.categories = res.data.data;
        // this.categories.forEach((item) => {
        //   this.slideBanner(item.ProductTypeName);
        //   // this.initSwiper(item.ProductTypeName, 0);
        // });

        this.changeCategory(this.categories[0].ProductTypeId);
        this.getActiveProductList(this.categories[0].ProductTypeId);
        res.data.data.forEach((item, index) => {
          this.getProductList(item.ProductTypeId, item.ProductTypeName, index);
        });
      });
    },
    getProductList(id, name, index) {
      get(
        ProductSummarizeList +
          "?ToProductTypeId=" +
          id +
          "&PageSize=0" +
          "&PageIndex=0"
      ).then((res) => {
        // console.log(res);
        let obj = {
          ProductTypeId: id,
          ProductTypeName: name,
          ProductTypeNameActive: 0,
          productsList: res.data.data,
        };
        this.$set(this.categoryList, index, obj);
        this.$nextTick(() => {
          this.slideBanner(index);
        });
      });
      // console.log(this.categoryList);
    },
    LearnMore(id) {
      this.$store.commit("SetProductId", id);
      this.$router.push("/Productinformation");
    },
    imgLoad() {
      this.$nextTick(() => {
        this.imgHeight = this.$refs.imgHeight["0"].height + "px";
      });
    },
    getActiveProductList(id) {
      get(
        ProductSummarizeList +
          "?ToProductTypeId=" +
          id +
          "&PageSize=6" +
          "&PageIndex=" +
          this.pageIndex
      ).then((res) => {
        this.products = res.data.data;
        this.total = res.data.count;
      });
    },
    changeCategory(categoryId) {
      // console.log(categoryId);

      this.activeCategory = categoryId;
      this.getActiveProductList(categoryId);
      // this.fetchProducts(categoryId)
    },
    selectProduct(productId) {
      this.activeProduct = productId;
      this.LearnMore(productId);
    },
    handleImageClick(row, index) {
      // 确保预览组件已初始化
      this.$nextTick(() => {
        // 获取预览组件实例
        const viewer = document.querySelector(".el-image-viewer");

        if (viewer) {
          // 1. 自动触发放大操作
          this.autoZoom(viewer);

          // 2. 设置初始缩放比例
          setTimeout(() => {
            const img = viewer.querySelector(".el-image-viewer__img");
            if (img) {
              img.style.transform = "scale(1.5)"; // 初始放大1.5倍
            }
          }, 50);
        }
      });
    },
    autoZoom(viewer) {
      // 查找放大按钮并模拟点击
      const zoomInBtn = viewer.querySelector(".el-image-viewer__zoom-in");
      if (zoomInBtn) {
        // 点击两次达到2倍放大效果（可根据需要调整次数）
        zoomInBtn.click();
        setTimeout(() => zoomInBtn.click(), 30);
      }
    },
    // 激活导航项方法
    activateNav(index) {
      this.activeNav = index;
    },

    goto(name) {
      if (name == "HOME") {
        window.sessionStorage.setItem("activeIndexh5", "/index");
        this.$router.push("/index");
      } else if (name == "PROJECT") {
        window.sessionStorage.setItem("activeIndexh5", "/Project");

        this.$router.push("/Project");
      } else if (name == "PRODUCTS") {
        window.sessionStorage.setItem("activeIndexh5", "/Productslist");
        document.documentElement.scrollTop = 0;
        // this.$router.push("/Productslist");
      } else if (name == "CASE") {
        window.sessionStorage.setItem("activeIndexh5", "/Case");
        this.$router.push("/Case");
        // window.open('https://smartuser.com.au/customerdetails/')
        // this.$router.push("/ProjectGallery")
      } else if (name == "CONTACTUS") {
        window.sessionStorage.setItem("activeIndexh5", "/ContactUs");

        this.$router.push("/ContactUs");
      }
    },
    // goinfo() {
    //   // window.sessionStorage.setItem("activeIndex", "/CustomerDetails");
    //   this.$emit("fun", "/CustomerDetails");
    // },
  },
};
</script>
<style>
/* 全局样式 - 放在你的全局CSS文件中 */
/* 增加预览容器尺寸 */
/* .el-image-viewer__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* 设置初始放大比例 */
/* .el-image-viewer__img {
  transform: scale(1.2) !important;
  transition: transform 0.3s ease;
} */

/* 隐藏操作按钮（可选） */
/* .el-image-viewer__btn {
  display: none !important;
} */
</style>
<style scoped lang="scss">
::v-deep .el-carousel__indicator.is-active .el-carousel__button {
  background-color: #409eff !important;
}
::v-deep .el-carousel__indicators--outside {
  margin-top: 8px !important;
}
::v-deep .el-carousel__indicator--horizontal {
  padding: 0 4px !important;
}
//箭头
::v-deep .el-icon-arrow-left {
  font-weight: 600;
}
::v-deep .el-icon-arrow-right {
  font-weight: 600;
}
::v-deep .el-carousel__arrow--left {
  left: 2px;
}
::v-deep .el-carousel__arrow--right {
  right: 2px;
}
::v-deep .el-carousel__arrow--left,
::v-deep .el-carousel__arrow--right {
  border: none;
  outline: 0;
  padding: 0;
  margin: 0;
  height: 24px;
  width: 24px;
  cursor: pointer;
  transition: 0.3s;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0);
  color: #0869b5;
  position: absolute;
  top: 50%;
  z-index: 10;
  text-align: center;
  font-size: 24px;
  // display: none;
  // top: 70px;
  // right: -13px;
  // font-size: 15px;
  // color: #02E9FF;
}
// ::v-deep .el-carousel__indicators--horizontal {
//   // transform: translateX(-50%) translateY(10px);
//   bottom: -20px;
//   width: 85.3%;
// }
.el-carousel__item .is-acitve {
  transition: transform 0.3s;
}
.el-carousel__item {
  opacity: 1;
}
::v-deep .el-carousel__button {
  left: auto;
  right: 10px;
  bottom: 10px;
  text-align: right;
  // top: 4.5%;
  // right: 22%;
  display: block;
  opacity: 0.48;
  width: 8px;
  height: 8px;
  background-color: #666;
  border: none;
  outline: 0;
  padding: 0;
  margin: 5px;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s;
}
.header-navbar {
  padding: 20px 40px;
  background-color: white;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}
.top-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.logo-container {
  flex-shrink: 0;
}
.logo {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-icon {
  font-size: 24px;
}
.logo-text {
  font-size: 18px;
  font-weight: 600;
}
.nav-items {
  display: flex;
  gap: 30px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
/* 下划线动画效果 */
/* .nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #1890ff;
  transition: width 0.3s;
} */
.nav-item:hover::after,
.nav-item.active::after {
  width: 100%; /* 悬停和激活时下划线宽度一致 */
}
.email-info {
  margin-top: 30px;
}
.email-content {
  font-size: 12px;
  color: #666;
  text-align: right;
  line-height: 1.6;
}
@media (max-width: 768px) {
  .top-nav {
    flex-direction: column;
    gap: 20px;
  }

  .nav-items {
    flex-wrap: wrap;
    justify-content: center;
    gap: 15px;
  }

  .email-content {
    text-align: center;
  }
}
</style>
<style scoped>
/* 移动端底部导航栏样式 */
.mobile-footer-navbar {
  background-color: white;
  padding: 20px;
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
}
.vertical-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.logo-section,
.nav-section,
.contact-section {
  text-align: left; /* 确保左对齐 */
}
.logo-container {
  margin-bottom: 10px;
}
.nav-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.nav-item {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  transition: all 0.3s;
  padding: 5px 0;
  position: relative;
  border-bottom: 2px solid transparent;
}
/* 悬停和激活状态统一效果 */
.nav-item:hover,
.nav-item.active {
  color: #0c80da !important;
  /* border-bottom-color: #0c80da !important; */
}
.contact-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.email-contentmobile {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
}
/* 响应式调整 */
@media (max-width: 480px) {
  .vertical-container {
    gap: 15px;
  }

  .nav-section {
    gap: 2px;
  }

  .nav-item {
    font-size: 14px;
    font-weight: bold;
  }

  .email-contentmobile {
    font-size: 12px;
  }
}
</style>
<style scoped>
.image-row {
  /* 这里可以添加额外的行样式，但通常 <el-row> 会有默认的样式 */
  margin: 0; /* 去除行容器的外边距 */
}

.image-col {
  /* 由于我们使用了 :gutter="0"，这里通常不需要额外的间距样式 */
  padding: 0; /* 去除列容器的内边距（虽然 <el-col> 默认可能没有内边距） */
}

.image-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  gap: 0; /* 设置图片之间的间距为0 */
  margin: 0; /* 去除容器自身的外边距 */
  padding: 0; /* 去除容器自身的内边距 */
}

.image-container > el-image {
  flex: 0 0 calc(50% - 0px); /* 每列占据50%的宽度，0px是调整间距的，这里不需要额外间距 */
  box-sizing: border-box; /* 确保内边距和边框包含在宽度内 */
}

.vc_custom_1627269981297copy {
  /* margin-bottom: -40px !important; */
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
}
/* .vc_custom_1626061515335 {
  margin-bottom: -40px !important;
  padding-top: 50px !important;
  padding-bottom: 40px !important;
  background-color: #84b903 !important;
} */
/* .special-link {
  text-decoration: underline;
}
a:link {
  color: blue;
} */
/* 已访问的链接 */
/* a:visited {
  color: purple;
} */

/* 鼠标悬浮在链接上 */
/* a:hover {
  color: red;
} */

/* .mt_20 {
  margin-top: 20px;
}
.mt_10 {
  margin-top: 10px;
}
.text_bold {
  font-weight: 700;
}
.pcss {
  font-family: Poppins;
  font-weight: 300;
  font-style: normal;
  font-size: 15px;
}
.titlecss {
  font-family: Poppins;
  font-style: normal;
} */

/* 图片容器相对定位 */
.banner-text {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  color: white;
  text-align: left;
  z-index: 10;
}

.text-line-1 {
  font-size: clamp(24px, 3vw, 48px);
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 8px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.text-line-2 {
  font-size: clamp(18px, 2.2vw, 36px);
  font-weight: 600;
  line-height: 1.2;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .banner-text {
    left: 8%;
  }
}

@media (max-width: 992px) {
  .banner-text {
    left: 6%;
  }
}

@media (max-width: 768px) {
  .banner-text {
    left: 5%;
  }

  .text-line-1 {
    font-size: clamp(20px, 4vw, 32px);
  }

  .text-line-2 {
    font-size: clamp(16px, 3vw, 24px);
  }
}
</style>
<style scoped>
/* 响应式设计 */
@media (max-width: 768px) {
  .centered-swiper-container {
    padding: 10px;
  }

  .slide-content {
    height: 240px; /* 移动端稍微调小 */
  }

  .media-element {
    height: 180px; /* 移动端媒体元素高度 */
  }

  .video-container {
    height: 180px;
  }

  video.media-element {
    height: 180px;
  }

  .video-loading {
    height: 180px;
  }

  .custom-pagination-container {
    gap: 6px;
    margin-top: 20px;
  }

  .custom-bullet {
    width: 10px;
    height: 10px;
  }

  .custom-bullet.active-bullet {
    width: 30px;
    height: 5px;
  }
}

/* 小屏幕手机特别优化 */
@media (max-width: 480px) {
  .slide-content {
    height: 220px; /* 手机端更小 */
  }

  .media-element {
    height: 160px;
  }

  .video-container {
    height: 160px;
  }

  video.media-element {
    height: 160px;
  }

  .video-loading {
    height: 160px;
  }
}

@media screen and (min-width: 1200px) {
  .product-item {
    height: 386px;
    /* width: 364px; */
    margin-right: 36px;
    cursor: pointer;
    transition: all 0.3s;
    margin-top: 98px;
  }
  .product-item img {
    height: 240px;
    margin-bottom: 32px;
  }
  .product-info {
    width: 386px;
    text-align: center;
  }
  .product-name {
    font-size: 20px;
    color: #333;
  }
  .product-name_KeyPra {
    font-size: 16px;
    text-align: left;
    height: 42px;
    color: #666;
    /* overflow: hidden; */
  }
  .categories {
    width: 276px;
    margin-right: 86px;
    margin-left: 140px;
    margin-top: 70px;
    font-family: Cotyledon-Regular-bold;
    /* border-radius: 8px; */
    overflow: hidden;
  }
  .category-itemtitle {
    font-family: Cotyledon-Regular-bold;
    text-align: left;
    width: 276px;
    height: 44px;
    font-size: 22px;
    line-height: 1;
    margin-bottom: 10px;
    padding: 10px 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: linear-gradient(to right, #007bff, #28a745);
    color: white;
    /* border-bottom: 1px solid #ddd; */
    /* margin: 5px; */
  }
  .category-item {
    font-family: Cotyledon-Regular;
    text-align: left;
    width: 276px;
    height: 44px;
    font-size: 20px;
    line-height: 1;
    margin-bottom: 6px;
    padding: 10px 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #fff; /* 未选中状态背景 */
    color: #000; /* 未选中状态字体黑色 */
    /* border-bottom: 1px solid #ddd; */
    /* margin: 5px; */
  }

  .category-item:last-child {
    border-bottom: none;
  }
  /* 产品网格布局 */
  .products-grid {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
    margin-bottom: 98px;
  }
  .product-page {
    width: 1920px;

    display: flex;
    margin: 0 auto;
    padding: 20px 0;
  }
  .logowidth {
    width: 1920px;
  }
}
@media (max-width: 1200px) {
  .logowidth {
    width: 100%;
  }
  .product-page {
    display: flex;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 0;
  }

  /* 分类导航样式 */
  .categories {
    width: 172px;
    margin-left: 90px;
    margin-right: 50px;
    font-family: Cotyledon-Regular-bold;
    /* border-radius: 8px; */
    overflow: hidden;
  }
  .product-item img {
    height: 150px;
    margin-bottom: 12px;
  }
  /* 产品网格布局 */
  .products-grid {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px;
    margin-bottom: 50px;
  }

  .product-item {
    height: 240px;
    margin-right: 20px;
    cursor: pointer;
    transition: all 0.3s;
    margin-top: 60px;
  }

  .product-info {
    width: 228px;
    text-align: center;
  }
  .product-name {
    font-size: 12px;
    color: #333;
  }
  .product-name_KeyPra {
    font-size: 10px;
    text-align: left;
    height: 28px;
    /* overflow: hidden; */
  }
  .category-itemtitle {
    font-family: Cotyledon-Regular-bold;
    text-align: left;
    width: 172px;
    height: 28px;
    font-size: 14px;
    line-height: 1;
    margin-bottom: 6px;
    padding: 5px 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: linear-gradient(to right, #007bff, #28a745);
    color: white;
    /* border-bottom: 1px solid #ddd; */
    /* margin: 5px; */
  }
  .category-item {
    font-size: 12px;
    font-family: Cotyledon-Regular;
    text-align: left;
    width: 172px;
    height: 28px;
    line-height: 1;
    margin-bottom: 6px;
    padding: 5px 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    background-color: #fff; /* 未选中状态背景 */
    color: #000; /* 未选中状态字体黑色 */
    /* border-bottom: 1px solid #ddd; */
    /* margin: 5px; */
  }
}

.category-item:last-child {
  border-bottom: none;
}
/* 悬停状态 */
.category-item:hover {
  /* background: linear-gradient(to right, #007bff, #28a745); */
  background: #eee;
  transform: translateX(5px);
}

/* 选中状态 */
.category-item.active {
  /* background: linear-gradient(to right, #007bff, #28a745);*/
  background: #eee;
  /* font-weight: bold; */
  /* box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3); */
}

/* .product-name_KeyPra:hover {
  height: auto;
  overflow: unset;
} */
.product-line {
  /* width: 228px; */
  height: 2px;
  background-color: #eee;
  margin-top: 8px;
  transition: all 0.3s;
}

/* 悬停和激活状态 */
.product-item:hover,
.active-product {
  transform: translateY(-5px);
}

.product-item:hover .product-line,
.active-product .product-line {
  background-color: #1890ff;
}
.product-item:hover img {
  scale: 1.1;
  transition: all 0.3s ease;
}
.product-item:hover .product-name {
  color: #1890ff;
}
.product-item:hover .product-name_KeyPra {
  color: #000;
}
</style>
